import axios, { AxiosResponse } from 'axios';

import { EUpozorneni } from 'enums/statniSprava/upozorneni';

export interface IStatniSpravaPutResp {
    upozor: {
        typ: EUpozorneni;
    }[];
    datum: string;
    redirect?: string;
}

export const odeslaniFsluzbyApi = (id: number, typ: 'CERT' | 'PW' | 'BI') => {
    // sluzba napr F42, F18 etc
    return axios({
        method: 'POST',
        url: `Sluzby/Poslat/${typ === 'CERT' ? 'Cert' : typ === 'BI' ? 'Bi' : 'Mob'}/${id}`
    }).then((resp: AxiosResponse<IStatniSpravaPutResp>) => resp.data);
};
